import type { ButtonHTMLAttributes } from "react";

import "./tones.css";
import "./button.css";
import "./focus.css";
import { buttonClass, type ButtonSize, type ButtonTone, type ButtonVariant } from "./button-class";

export type { ButtonSize, ButtonTone, ButtonVariant } from "./button-class";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  tone?: ButtonTone;
  size?: ButtonSize;
}

/**
 * The standard button. Styled by design tokens through the variant×tone×size grammar
 * (tone slots in tones.css), so a re-skin edits tokens, not this component. `type`
 * defaults to "button" to avoid accidental form submits.
 */
export function Button({
  variant = "solid",
  tone = "accent",
  size = "md",
  className,
  type = "button",
  ...rest
}: ButtonProps) {
  return <button type={type} className={buttonClass(variant, tone, size, className)} {...rest} />;
}
